import { useState, useEffect } from "react";
import side_img from "../../assets/pic/login_signup_img.svg";
import { toast } from "react-toastify";
import Spinner from "../../components/Spinner";
import { Link } from "react-router-dom";
import { MdOutlineKeyboardBackspace } from "react-icons/md";
import ForgotPasswordOTP from "../../components/ForgotPasswordOTP";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [loader, setLoader] = useState(false);
  const [OTPModal, setOTPModal] = useState(false);

  const handleOpenOTPModal = () => {
    setOTPModal(true);
  };

  const handleCloseOTPModal = () => {
    setOTPModal(false);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoader(true);

    const forgotpassword = async () => {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/api/auth/forget-password`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email,
          role: "customer",
        }),
      });
      const data = await res.json();
      setLoader(false);
      if (data.code === 200 && data.message === "Verify OTP") {
        toast.info("OTP has been sent to your email ID");
        handleOpenOTPModal();
      }
    };
    forgotpassword();
  };

  useEffect(() => {
    // Prevent scrolling of body content when the modal is open
    if (OTPModal) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [OTPModal]);

  return (
    <section className="relative flex xl:flex-row h-screen">
      <div>
      <img
        src={side_img}
        alt="login_signup_side_bg"
        // className="fixed left-0 top-0 w-full xl:w-1/2 h-full bg-no-repeat bg-cover z-0"
        className="fixed left-0 top-0 w-1/2 xl:flex hidden  h-full bg-no-repeat bg-cover z-0" 

      />
      </div>
      {OTPModal && (
        <ForgotPasswordOTP
          handleCloseOTPModal={handleCloseOTPModal}
          email={email}
        />
      )}
      {/* <div className="xl:w-1/2 w-full h-full overflow-y-auto"></div> */}
      <div className="flex items-center justify-center h-full overflow-y-auto xl:flex hidden w-1/2"></div>

      <form
        onSubmit={handleSubmit}
        className="md:text-xl text-lg md:p-10 p-5 space-y-5 xl:w-[40%] w-full md:m-0 my-10 h-screen flex flex-col justify-center"
      >
        <h1 className="text-4xl font-semibold">Forgot Password?</h1>
        <div className="flex flex-col w-full">
          <p className="text-lg text-gray-500">
            Enter registered email Id to reset your password
          </p>
          <label className="my-2 text-lg font-semibold">Email ID</label>
          <input
            type="text"
            name="email"
            value={email}
            required
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Please enter your email ID"
            className={`py-3 bg-none border-b-[3px] placeholder:text-gray-400 w-full`}
          />
        </div>
        {loader ? (
          <Spinner props=" " size={"80"} />
        ) : (
          <button className="bg-primary text-white rounded-md py-3 hover:bg-primary-dark">
            Reset Password
          </button>
        )}
        <Link to="/login" className="mx-auto">
          <p className="flex items-center gap-x-3 text-blue-700">
            {" "}
            <span>
              <MdOutlineKeyboardBackspace />
            </span>
            Back to Sign in
          </p>
        </Link>
      </form>
    </section>
  );
};

export default ForgotPassword;
